<template>
    <div v-scroll:throttle="{fn: onScroll, throttle: 500 }" class="pc-news-center">
        <div class="pchome-headerss top-header">
            <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
        </div>

        <div style="height: 60px">
            <position-bar :linesd="false" class="position-bar" ref="positionNav" :productc_nav="producthea_nav" :positionNav="positionNav" >

            </position-bar>
        </div>

        <div class="slider">
            <el-carousel :interval="5000" arrow="always" :height="imgHeight">
                <el-carousel-item v-for="(item,index) in banners" :key="index" >
                    <img :src="item.image" alt="" ref="imgHeight" mode="widthFix" @load="imgLoad" @click="toDetail(item)">
                </el-carousel-item>
            </el-carousel>
        </div>

        <div class="news" >
            <div class="news-list">
                <div class="item" v-for="item in news.list" @click="toDetail(item)">
                    <div class="clear-fix item-box">
                        <div class="thumb float-left" >
                            <img :src="item.thumb" alt="">
                        </div>
                        <!--                        <div class="date float-left">-->
                        <!--                            <div class="date-box">-->
                        <!--                                <div class="day">{{ item.day }}</div>-->
                        <!--                                <div class="year-month">{{ item.yearMonth }}</div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <div class="text float-left">
                            <div class="text-box">
                                <p class="date">{{ $utils.formatDateEn(item.createtime) }}</p>
                                <h3 class="line2">{{ item.en_title }}</h3>
                                <p class="line2">{{ item.en_description }}</p>
                                <!--                                <span>更多</span>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="bottom" class="bottom" >
            <span class="loadingText">{{ loadingText.text }}</span>
        </div>
        <footers ref=is_change ></footers>
    </div>
</template>

<script>
    import 'lib-flexible/flexible.js'
    import {session} from '../../storage/storage.js';
    import headers from '../../common/header.vue'
    import footers from '../../common/footers.vue'
    import positionBar from '../../components/position-bar.vue'

    export default {
        name: "pc-news",
        components:{
            headers,
            footers,
            positionBar,
        },
        data(){
            return {
                producthea_nav:false,
                nav_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d',
                videoclassallss:[],
                title:'新闻中心',
                videotopnavind:0,
                banners:[],
                imgHeight: '',
                news:{
                    list:[]
                },
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'News',
                        path:'',
                    },
                ],
                loading:false,
                page:{
                    current_page:1,
                    last_page:1,
                    per_page:1
                },
                loadingText:{
                    more:'MORE',
                    loading:'LOADING',
                    no_more:'NO MORE',
                    text:'more'
                },
            }
        },
        created(){

        },
        watch:{
            '$route': 'getParams'
        },
        mounted() {

            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                console.log('手机手机21321321')
                this.$router.push({path:'./ph-news',query:{e:this.$route.query.e}})
            }

            sessionStorage.setItem('page',JSON.stringify({name:'pc-news',data:false}))

            this.initData()
        },
        destroyed() {
            window.onresize = null
        },

        methods:{
            onScroll: function(e, position) {

                let scrollTop = position.scrollTop
                let head_height = this.$refs.head.getHeaderHeight()

                if(scrollTop>head_height){
                    // if(scrollTop>this.scroll_height){
                    this.producthea_nav = true
                    // }else{
                    // 	this.producthea_nav = false
                    // }
                    this.scroll_height = scrollTop
                }else{
                    this.producthea_nav = false
                }
                this.$refs.head.scrollTop_change(scrollTop)
                if(!this.$utils.isElementNotInViewport(this.$refs.bottom)){
                    if(this.loading){
                        return
                    }
                    this.loading = true
                    this.loadingText.text = this.loadingText.loading
                    this.newsCenterList()
                }
            },
            newsCenterList(){
                const _this = this

                _this.page.current_page ++
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:_this.page.current_page,
                }

                _this.$api.get_news_center_list(data).then(res => {
                    _this.page.current_page = res.data.current_page
                    _this.page.last_page = res.data.last_page
                    _this.page.per_page = res.data.per_page
                    _this.news.list = _this.news.list.concat(res.data.data)
                    _this.checkoutDataEnd()
                })
            },
            checkoutDataEnd(){
                if(this.page.current_page >= this.page.last_page){
                    this.loading = true
                    this.loadingText.text = this.loadingText.no_more
                }else {
                    this.loading = false
                    this.loadingText.text = this.loadingText.more
                }
            },
            initData(){
                const _this = this
                _this.loading =true
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                }
                Promise.all([new Promise((resolve, reject) => {
                        this.$api.get_news_center_slider(data).then(res => {
                            resolve(res)
                        })
                    }),new Promise((resolve, reject) => {
                    _this.$api.get_news_center_list(data).then(res => {
                        _this.page.current_page = res.data.current_page
                        _this.page.last_page = res.data.last_page
                        _this.page.per_page = res.data.per_page
                        _this.checkoutDataEnd()
                            resolve(res)
                        })
                    })
                ]).then(res => {
                    _this.banners = res[0].data
                    _this.news.list = res[1].data.data
                    this.loading =false
                    window.onresize = () => {
                        _this.imgLoad()
                    }
                })
            },
            toDetail(item){
                this.$router.push({path: '/pc-news-detail',query:{id:item.id}})
            },
            imgLoad() {
                // 获取图片高度
                this.$nextTick(() => {
                    this.imgHeight = this.$refs.imgHeight['0'].height + 'px'
                })
            },
            ChangeEmit(){ //子组件传递
                //主动调用子组件
                this.$refs.is_change.get_index_channel_data();
                this.$refs.is_change.pageParam();
            },
            videoclinav(e){
                this.videotopnavind=e
                this.classidd=this.videoclassallss[e].id
                // this.videoclasslist()
            },
            handleScroll () {
                let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
                let head_height = this.$refs.head.getHeaderHeight()
                if(scrollTop>head_height){
                    // if(scrollTop>this.scroll_height){
                    this.producthea_nav = true
                    // }else{
                    // 	this.producthea_nav = false
                    // }
                    this.scroll_height = scrollTop
                }else{
                    this.producthea_nav = false
                }
                this.$refs.head.scrollTop_change(scrollTop)
            },
        }
    }
</script>


<style >
    .pc-news-center .bottom {
        text-align: center;
    }

    .pc-news-center .bottom .loadingText {
        font-size:14px;
        color: #7f7f7f;
        border: 1px solid #7f7f7f;
        display: block;
        width: .6rem;
        padding: 10px 0;
        margin: 0 auto 30px auto;
        border-radius: 100px;
        cursor: pointer;

    }
    .pc-news-center {
        width: calc(100vw);
        height: calc(100vh);
        overflow-x: hidden;
        position: relative;
        background: #fff;
    }
    .producthea_nav{
        top: 0;
        position: fixed;
        z-index: 9;
        background-color: #fff;
        background: rgba(255,255,255,.72);
        backdrop-filter: saturate(180%) blur(20px);
    }
    .videohea{
        width: 1400px;
        /* height: 80px; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 260px;
    }
    .videohea-left{
        font-size: 28px;
        color: #5d5f5f;
    }
    .videohea-right{
        display: flex;


    }
    .videohea-righttitle{
        max-width: 800px;

        display: flex;

        font-size: 16px;
        flex-wrap: wrap;
        margin-left: -24px;
        color: #5d5f5f;
    }
    .producthearight-item{
        margin-bottom: 10px;
        cursor: pointer;
        margin-left: 24px;
    }
    .producthearight-item:first-child{
        margin-left: 0px;
    }
    .videohea-righticon{
        width: 20px;
        height: 20px;
        margin-left: 9px;
        display: flex;
        align-items: center;
    }
    .videohea-righticon img{
        width: 100%;
        height: 100%;
    }
    .linesd{
        width: 1400px;
        height: 1px;
        background: #EAEAEA;
        margin: 0 auto;
    }

    .slider .el-carousel__container {
        /*height: 100%;*/
    }
    .slider .el-carousel__container .el-carousel__item img {
        width: 100%;
        cursor: pointer;
    }

    .slider .el-carousel__button {
        height: 2px;
        width: 30px;
    }

    .news {
        width: 1400px;
        margin: 0 auto;
    }
    .news .news-list {
        padding: 30px 0;
    }
    .news .news-list .item {
        margin-top: 30px;
        font-size: 30px;
        box-shadow: 0 6px 20px 0 rgba(0,0,0,.1);
        cursor: pointer;
        border-radius: 20px;
        overflow: hidden;
    }
    .news .news-list .item .item-box {

    }
    .news .news-list .item .thumb {
        width: 525px;
        height: 334px;
    }

    .news .news-list .item .thumb img {
        width: 525px;
        height: 334px;
        display: block;
    }
    /*.news .news-list .item .date {*/
    /*    width: 200px;*/
    /*    text-align: center;*/
    /*}*/
    /*.news .news-list .item .date .date-box {*/
    /*    padding-top: 30px;*/
    /*    color: #7f7f7f;*/
    /*}*/
    /*.news .news-list .item .date .date-box .day{*/
    /*    font-size: 50px;*/
    /*    font-weight: bold;*/
    /*}*/
    /*.news .news-list .item .date .date-box .year-month {*/
    /*    margin-top: 10px;*/
    /*}*/
    .news .news-list .item .text {
        width: 750px;
    }
    .news .news-list .item .text .text-box {
        padding: 30px 0 50px 30px;
        position: relative;
        /*height: 250px;*/
    }
    .news .news-list .item .text .text-box .date{
        font-size: 20px;
    }
    .news .news-list .item .text .text-box h3 {
        font-size: 26px;
    }
    .news .news-list .item .text .text-box p {
        margin-top: 10px;
        margin-bottom: 20px;
        font-size: 22px;
        color: #7f7f7f;
    }
    .news .news-list .item .text .text-box p:nth-of-type(2){
        margin-top: 50px;
    }
    .news .news-list .item .text .text-box span {
        padding: 10px 30px;
        border: 1px solid #7f7f7f;
        color: #7f7f7f;
        font-size: 20px;
        position: absolute;
        right: 0px;
        bottom: 0px;
    }
</style>